@let r = result();

<div class="rv-layout" [class.rv-layout--empty]="!r.results.length">
  <!-- Side column on a wide panel; above the gallery otherwise. -->
  <aside class="rv-rail" aria-label="Summary">
    @if (r.results.length) {
      <app-top-sites [entries]="r.results" [selected]="siteFilter()" (toggle)="toggleSite($event)" (clear)="clearSites()" />
    }

    @if (missingFields().length) {
      <p class="rv-tip">
        @for (f of missingFields(); track f.label; let last = $last) {
          Turn on <strong>{{ f.label }}</strong> to see {{ f.adds }}.@if (!last) {<br />}
        }
        <span class="rv-tip__where">{{ missingFields().length > 1 ? 'Both are' : 'It\'s' }} in Response configuration.</span>
      </p>
    }
  </aside>

  <div class="rv-main">
    <div class="rv-toolbar">
      <span class="img-count">
        <span class="rv-key" appFieldTip="meta.count" [tipText]="tips.count"><strong>{{ r.meta.count | number }}</strong> image{{ r.meta.count === 1 ? '' : 's' }}</span>
        @if (r.meta.totalMatches !== null && r.meta.totalMatches > r.meta.count) {
          <span class="rv-key" appFieldTip="meta.total_matches" [tipText]="tips.totalMatches">of {{ r.meta.totalMatches | number }} matches</span>
        }
        @if (brokenCount()) {
          <span class="img-count__broken" role="status">· {{ brokenCount() }} couldn't load</span>
        }
      </span>
      @if (siteFilter().size; as picked) {
        @let n = filtered().length;
        <span class="rv-filter" role="status">
          {{ n }} image{{ n === 1 ? '' : 's' }} from
          @if (picked === 1) {
            <strong>{{ siteFilter().values().next().value }}</strong>
          } @else {
            <strong>{{ picked }} sites</strong>
          }
          <button type="button" class="rv-filter__clear" (click)="clearSites()" aria-label="Show images from all sites">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M3 3l6 6M9 3l-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          </button>
        </span>
      } @else if (r.results.length) {
        <span class="rv-toolbar__hint">Click an image for its details</span>
      }
    </div>

    @if (!r.results.length) {
      <div class="rv-empty">
        <svg class="rv-empty__icon" width="40" height="40" viewBox="0 0 48 48" fill="none" aria-hidden="true"><circle cx="21" cy="21" r="12" stroke="currentColor" stroke-width="2"/><path d="M30 30l9 9M16 21h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
        <p class="rv-empty__title">No images matched this query.</p>
        <p class="rv-empty__desc">Try a wider date range, fewer filters, or different keywords.</p>
      </div>
    } @else {
      <!-- Justified rows: each tile's width follows its proportions, so a row
           shares one height; the trailing filler keeps the last row from stretching. -->
      <ul class="gallery">
        @for (v of shown(); track v.index; let i = $index) {
          @let failed = broken().has(v.index);
          <!-- A tile that couldn't load from any source shrinks to a small square,
               so failures don't take the room of real pictures; it still opens the lightbox. -->
          <li class="tile" [class.tile--broken]="failed"
              [style.flex-grow]="failed ? 0 : v.aspect * 100" [style.width.px]="failed ? row * 0.75 : v.aspect * row">
            <button type="button" class="tile__btn" (click)="open(i)"
                    [attr.aria-label]="(failed ? 'Image couldn\'t load, open details: ' : 'Open image: ') + v.label">
              <i class="tile__space" [style.padding-bottom.%]="failed ? 100 : 100 / v.aspect"></i>
              @if (failed) {
                <span class="tile__broken">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M3 16l5-5 4 4M14 13l2-2 5 5M4 4l16 16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  <span class="tile__broken-site">{{ v.hit.host }}</span>
                </span>
              } @else {
                <img class="tile__img" [src]="src(v)" alt="" loading="lazy" (error)="imageFailed(v)" />
                <span class="tile__site">{{ v.hit.host }}</span>
              }
            </button>
          </li>
        }
        <li class="gallery__filler" aria-hidden="true"></li>
      </ul>

      @if (filtered().length > shown().length) {
        <button type="button" class="btn--secondary rv-more" (click)="showMore()">
          Show more ({{ filtered().length - shown().length }} left)
        </button>
      }
    }
  </div>
</div>
